import { createContext } from 'react';

interface RadioGroupProps {
  defaultValue?: number | string;
  disabled?: boolean;
  name?: string;
  onChange?: (event: { value: string | number | undefined; select: boolean }) => void;
}

export const RadioboxGroupContext = createContext<RadioGroupProps | null>(null);

export const RadioboxGroupContextProvider = RadioboxGroupContext.Provider;
